import { useEffect, useState, type FC } from 'react';
import { supervisorApi } from '@/features/workspace/api';
import '@/features/student/sv121.css';
import '@/features/student/tp201-projects.css';

type SupervisorProjectRow = {
  id: string;
  title: string;
  status: string;
  stage: string;
  member_count: number;
  summary?: string | null;
};

interface SupervisorProjectsPageProps {
  onClose?: () => void;
}

export const SupervisorProjectsPage: FC<SupervisorProjectsPageProps> = ({ onClose }) => {
  const [projects, setProjects] = useState<SupervisorProjectRow[]>([]);

  useEffect(() => {
    supervisorApi
      .module('projects', { tab: 'overview' })
      .then((payload) => setProjects((payload?.items as SupervisorProjectRow[] | undefined) || []))
      .catch(() => setProjects([]));
  }, []);

  return (
    <div className="tp201-root" role="dialog" aria-modal="true">
      <header className="tp201-top">
        <button type="button" onClick={onClose}>← Назад</button>
        <div>
          <h1>Научные работы с обучающимися</h1>
          <p>SUPERVISOR · проекты, этапы, задачи и результаты</p>
        </div>
        <button type="button" onClick={onClose}>Закрыть ×</button>
      </header>
      <main className="tp201-content">
        <section className="sv121-panel" style={{ ['--c' as string]: '#49ddb7' }}>
          <span className="sv121-eyebrow">СОВМЕСТНЫЕ НАУЧНЫЕ РАБОТЫ</span>
          <h2>Проекты, конкурсы и роли обучающихся</h2>
          <p>Этапы, задачи, материалы, консультации, презентации и результаты по работам, которые руководитель ведёт вместе с обучающимися.</p>
        </section>
        <div className="tp201-project-grid">
          {projects.map((project) => (
            <article key={project.id} className="tp201-project-card" style={{ ['--c' as string]: '#49ddb7' }}>
              <small>{project.stage || 'Этап в работе'}</small>
              <h3>{project.title}</h3>
              <p>{project.summary || 'Совместная научная работа'}</p>
              <div className="tp201-project-meta">
                <span className="tp201-status info">{project.member_count} участника</span>
                <span className={`tp201-status ${project.status === 'IN_PROGRESS' ? 'warn' : 'ok'}`}>{project.status}</span>
              </div>
            </article>
          ))}
        </div>
        {projects.length === 0 ? <div className="sv121-empty">Совместных работ пока нет.</div> : null}
      </main>
    </div>
  );
};
